import React from 'react';
import { DarkMode } from 'use-dark-mode';

import {
    LoginForm,
    UserAONLayout,
    UserLayout,
    UserHectorLayout,
    UserSgiffoxxLayout,
    UserAonMotorLayout,
    UserCeatLayout,
    UserCeatMaklerLayout,
} from 'src/user-management';
import { AonThemeProvider } from 'src/shared/hocs/aon-theme-provider';
import { HectorThemeProvider } from 'src/shared/hocs/hector-theme-provider';
import { AonMotorThemeProvider } from 'src/shared/hocs/aon-motor-theme-provider';
import { CeatThemeProvider } from 'src/shared/hocs/ceat-theme-provider';

import { appInstance } from 'src/environment';

import { AppInstances } from 'src/shared/constants';

interface Props {
    darkMode: DarkMode;
}

export const LoginPage = ({ darkMode }: Props): JSX.Element => {
    switch (appInstance) {
        case AppInstances.AON:
        case AppInstances.AON_KOMPOSIT: {
            return (
                <AonThemeProvider>
                    <UserAONLayout darkMode={darkMode}>
                        <LoginForm darkMode={darkMode} />
                    </UserAONLayout>
                </AonThemeProvider>
            );
        }
        case AppInstances.SGIFFOXXK: {
            return (
                <UserSgiffoxxLayout darkMode={darkMode}>
                    <LoginForm darkMode={darkMode} />
                </UserSgiffoxxLayout>
            );
        }
        case AppInstances.HECTOR: {
            return (
                <HectorThemeProvider>
                    <UserHectorLayout darkMode={darkMode}>
                        <LoginForm darkMode={darkMode} />
                    </UserHectorLayout>
                </HectorThemeProvider>
            );
        }
        case AppInstances.AON_MOTOR:
        case AppInstances.AON_DIGITAL:
        case AppInstances.HECTOR_DEMO: {
            return (
                <AonMotorThemeProvider>
                    <UserAonMotorLayout darkMode={darkMode}>
                        <LoginForm darkMode={darkMode} />
                    </UserAonMotorLayout>
                </AonMotorThemeProvider>
            );
        }
        case AppInstances.CEAT: {
            return (
                <CeatThemeProvider>
                    <UserCeatLayout darkMode={darkMode}>
                        <LoginForm darkMode={darkMode} />
                    </UserCeatLayout>
                </CeatThemeProvider>
            );
        }
        case AppInstances.CEAT_MAKLER: {
            return (
                <CeatThemeProvider>
                    <UserCeatMaklerLayout darkMode={darkMode}>
                        <LoginForm darkMode={darkMode} />
                    </UserCeatMaklerLayout>
                </CeatThemeProvider>
            );
        }
        default: {
            return (
                <UserLayout darkMode={darkMode}>
                    <LoginForm darkMode={darkMode} />
                </UserLayout>
            );
        }
    }
};
